import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const MATERIALS_DATA = [
  {
    id: 1,
    title: "Automotive Division",
    description:
      "Lighting solutions for two-wheelers, passenger vehicles, commercial vehicles, and tractors. From halogen headlamps to signaling bulbs.",
    image: "Big-division/automotive.png",
  },
  {
    id: 2,
    title: "Defence & Aerospace",
    description:
      "Mission-critical lighting systems for military vehicles, naval platforms, aircraft, and ground support applications.",
    image: "Big-division/aerospace.png",
  },
  {
    id: 3,
    title: "Airfield Lighting",
    description:
      "Runway lighting systems, airfield lamps, and specialized aviation ground lighting.",
    image: "Big-division/airfield.jpg",
  },
];

const BigDivision = ({ isDesktop, THEME }) => {
  return (
    <section
      id="divisions"
      style={{
        position: "relative", // 🔑 REQUIRED for layered background
        backgroundColor: "transparent",
        paddingTop: isDesktop ? "120px" : "80px",
        // paddingBottom: isDesktop ? "120px" : "80px",
        overflow: "hidden",
      }}
    >
      {/* 🔴 HALF RED BACKGROUND (NEW) */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: isDesktop ? "58%" : "48%", // tweak if client wants more/less
          backgroundColor: "#cc0000",
          zIndex: 0,
        }}
      />

      {/* CONTENT WRAPPER */}
      <div style={{ position: "relative", zIndex: 2 }}>
        {/* HEADER */}
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "0 24px 48px 24px",
            textAlign: "right",
          }}
        >
          <h3
            style={{
              color: THEME.colors.accent, // 🔑 contrast on red
              fontSize: "14px",
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              marginBottom: "16px",
            }}
          >
            Sectors
          </h3>
          <h2
            style={{
              color: "white",
              fontSize: "32px",
              fontWeight: 900,
              textTransform: "uppercase",
              margin: 0,
              maxWidth: "900px",
              marginLeft: "auto",
            }}
          >
            Comprehensive Lighting Solutions Across Sectors
          </h2>
        </div>

        {/* GRID */}
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: isDesktop ? "0 24px" : "0 16px",
            display: "grid",
            gridTemplateColumns: isDesktop ? "repeat(3, 1fr)" : "1fr",
            gap: "32px",
          }}
        >
          {MATERIALS_DATA.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{
                opacity: 0,
                y: 80,
                rotateX: -15,
                transformOrigin: "bottom center",
              }}
              whileInView={{
                opacity: 1,
                y: 0,
                rotateX: 0,
              }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1], // smooth cinematic easing
                delay: index * 0.12,
              }}
              style={{
                position: "relative",
                height: isDesktop ? "420px" : "360px",
                overflow: "hidden", // 🔑 REQUIRED for roll effect
                backgroundColor: "#000",
                perspective: "1200px", // 🔑 gives depth to roll
              }}
            >
              {/* IMAGE */}
              <motion.img
                src={item.image}
                alt={item.title}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.5 }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* CONTENT */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: "28px",
                  color: "white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.25))",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                }}
              >
                <div>
                  <h3
                    style={{
                      fontSize: isDesktop ? "26px" : "22px",
                      fontWeight: 900,
                      textTransform: "uppercase",
                      margin: "0 0 8px 0",
                      lineHeight: 1.1,
                    }}
                  >
                    {item.title}
                  </h3>

                  <p
                    style={{
                      fontSize: "14px",
                      lineHeight: 1.6,
                      color: "rgba(255,255,255,0.85)",
                      margin: 0,
                      maxWidth: "360px",
                    }}
                  >
                    {item.description}
                  </p>
                </div>

                {/* CTA */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  style={{
                    width: "48px",
                    height: "48px",
                    backgroundColor: "#cc0000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <ArrowUpRight size={20} />
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BigDivision;
